import { createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/brand/gtr-evolution-logo-color-on-dark.svg'


const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-md-9 col-lg-8 col-xl-6" }
const _hoisted_3 = { class: "card auth-form-card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "card-text" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "input-group" }
const _hoisted_8 = ["type"]
const _hoisted_9 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_10 = {
  key: 0,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_11 = { class: "input-group mb-1" }
const _hoisted_12 = { class: "auth-error-message-box text-center rounded-bottom small mx-3 text-light" }
const _hoisted_13 = {
  key: 0,
  class: "bg-danger bg-opacity-50 p-2"
}
const _hoisted_14 = {
  key: 0,
  id: "capslock-on",
  class: "ms-2 text-warning small"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "fa-sharp fa-solid fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        role: "form",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-center auth-brand-wrap" }, [
              _createElementVNode("img", {
                class: "auth-brand-logo",
                src: _imports_0,
                alt: "GTR Evolution"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-lock fa-fw" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: _ctx.showPassword ? 'text' : 'password',
                    class: "form-control",
                    placeholder: "Nueva contraseña",
                    "aria-label": "Contraseña",
                    id: "password",
                    ref: "password",
                    autocomplete: "current-password",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validatePasswords()))
                  }, null, 40, _hoisted_8), [
                    [
                      _vModelDynamic,
                      _ctx.loginForm.password,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-secondary pt-1",
                    type: "button",
                    id: "show-password",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-sharp fa-solid fa-xs fa-fw", _ctx.showPassword ? 'fa-eye-slash' : 'fa-eye'])
                    }, null, 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.validPassword)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.passwordValidation.userMessage), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "input-group-text" }, [
                    _createElementVNode("i", { class: "fa-sharp fa-solid fa-lock fa-fw" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control",
                    placeholder: "Confirmar nueva contraseña",
                    "aria-label": "Contraseña",
                    id: "confirmPassword",
                    ref: "confirmPassword",
                    autocomplete: "current-password",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginForm.passwordConfirm) = $event)),
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validatePasswords()))
                  }, null, 544), [
                    [
                      _vModelText,
                      _ctx.loginForm.passwordConfirm,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (!_ctx.validPasswordConfirm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-2 text-danger" }, null, -1),
                        _createTextVNode("Las contraseñas no coinciden. ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.capsLockOn)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("span", { class: "small" }, [
                        _createElementVNode("i", { class: "fa-sharp fa-solid fa-exclamation-triangle fa-fw me-1" }),
                        _createTextVNode(" BloqMayús (CapsLock) está activado. ")
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetPassword())),
                  class: "btn btn-primary my-4 w-100",
                  disabled: _ctx.invalidInputs()
                }, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Cambiar contraseña ", -1)),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_16)
              ])
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}